let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hgWTX")).then(() => parcelRequire('lJhGn'));